import { _ } from "../../core/polyglot/polyglot.js";
import Period from "./Period.js";

/**
 * `Week` is a period representing a week.
 * Instances should not be created by hand, but rather looked up
 * from `fiscalYear`.
 */
export default class Week extends Period {
	constructor(spec) {
		super(spec);

		this._periodId = `W${this._periodIndex}`;
	}

	getName() {
		return _("Week {number}", { number: this._periodIndex });
	}

	isWeek() {
		return true;
	}

	static getType() {
		return "Week";
	}
}
